module.exports = __webpack_public_path__ + "static/media/yogi3.c6a8ad4d.png";